import React, { useState, useEffect } from 'react';
import Card from '../Card.js';
import "./SearchProduct.css"
import { useParams, Link } from 'react-router-dom';
import { searchForProducts } from '../../network/api/product.js';
import { useTranslation } from "react-i18next";
const SearchProduct = ({update_p ,personal}) => {
  const {t} = useTranslation()
  const { searchKey, page } = useParams();
  const [currentPage, setCurrentPage] = useState(parseInt(page, 10) || 1);
  const [totalPages, setTotalPages] = useState(1);
  const [products, setProducts] = useState([]);



  useEffect(() => {
    // Fetch products for the current page
    const fetchProducts = async () => {
      try {
        const response=await searchForProducts({searchKey,currentPage})
        setProducts(response.data.products);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, [searchKey, currentPage]);
  useEffect(() => {
    // Fetch total pages
    const getTotalPages = async () => {
      try {
        const response=await searchForProducts({searchKey,currentPage})
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching total pages:', error);
      }
    };

    getTotalPages();
  }, [currentPage, searchKey]);

  // Function to handle page link clicks
  const handlePageClick = (newPage) => {
    setCurrentPage(newPage);
  };
  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Function to handle "Next" link click
  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  // Function to render page links
  const renderPageLinks = () => {
    const links = [];
    for (let i = 1; i <= totalPages; i++) {
      links.push(
        <Link
          key={i}
          to={`/search-results/${searchKey}/${i}`}
          className={i === currentPage ? 'active' : ''}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </Link>
      );
    }
    return links;
  };

  return (
    <div className='p-5'>
      {/* <div>{searchKey}</div> */}
     <h1>
     {t("searchForResultFor")} <span style={{color:'#F31503'}}>{searchKey}</span>
     </h1>
      {/* Display the products for the current page */}
        <div className='cards'>
            <div className='row'>
            {Array.isArray(products) &&
            products?.map((product, index) => (
              <div className="col-6 col-lg-3 mb-3 mb-lg-0" key={index}>
                <Card
                  ImageCard={
                    product?.images[0]?.secure_url &&
                    product.images[0]?.secure_url
                  }
                  update_p={update_p}
                  personal={personal}
                  brand={product.brand}
                  name={product.name}
                  price={product.price_after}
                  id={product._id}
                  rate={product.totalRate ? product.totalRate : 0}
                  new={false}
                  price_after={product.price_after}
                  price_before={product.price_before}
                  product={product}
                />
              </div>
            ))}
            </div>
            

        </div>

      {/* Display page links */}
      {totalPages >= 1 && (
        <div className="pagination ">
         <div className='me-3'>
         {currentPage > 1 && (
            <Link onClick={handlePreviousClick} to={`/search-results/${searchKey}/${currentPage - 1}`}>{t("previous")}</Link>
          )}
         </div>

          {renderPageLinks()}


            <div className='ms-3'>
            {currentPage < totalPages && (
            <Link onClick={handleNextClick} to={`/search-results/${searchKey}/${currentPage + 1}`}>{t("next")}</Link>
          )}
            </div>
        </div>
      )}
    </div>
  );
};

export default SearchProduct;
